import * as Sentry from "@sentry/react";
import { isAxiosError } from "axios";
import type { SWRConfiguration } from "swr";

/**
 * 失敗を画面内のエラー表示で知らせる法人マスタのフック用 SWR オプション。
 * グローバル SWRConfig.onError（App.tsx）の汎用トーストを重ねて出さず、
 * 5xx とネットワーク断だけを Sentry へ送る
 */
export const inlineErrorSwrOptions: SWRConfiguration = {
  onError: (error: unknown) => {
    if (
      isAxiosError(error) &&
      (error.response == null || error.response.status >= 500)
    ) {
      Sentry.captureException(error);
    }
  },
};
